$(document).ready(function () {
  if ($('.shares-show-page').length) {
    setTimeout(() => {
      $('.click-notice').alert('close')
    }, 5000);
  }
})